import { useMemo } from 'react';
import { css } from 'styled-components';
export const TIMEOUT_IN = 500;
export const TIMEOUT_OUT = 300;
export const EASE = [0.5, 0, 0, 1];
export const flyoutTransitionMixin = (...properties) => {
    const propertiesString = properties.join(', ');
    return css `
    transition-property: ${propertiesString};
    transition-duration: ${({ theme }) => theme.isFlyout ? TIMEOUT_IN : TIMEOUT_OUT}ms;
    transition-timing-function: cubic-bezier(${EASE.join(', ')});
  `;
};
export const flyoutTransition = {
    type: 'tween',
    ease: EASE,
    precision: 0.01,
};
export const useFlyoutVariants = ({ initial, animate, exit, }) => {
    return useMemo(() => ({
        initial: 'initial',
        animate: 'animate',
        exit: 'exit',
        variants: {
            initial: Object.assign(Object.assign({}, initial), { transition: Object.assign(Object.assign({}, flyoutTransition), { duration: TIMEOUT_IN / 1000 }) }),
            animate: Object.assign(Object.assign({}, animate), { transition: Object.assign(Object.assign({}, flyoutTransition), { duration: TIMEOUT_IN / 1000 }) }),
            exit: Object.assign(Object.assign({}, exit), { transition: Object.assign(Object.assign({}, flyoutTransition), { duration: TIMEOUT_OUT / 1000 }) }),
        },
    }), [animate, exit, initial]);
};
//# sourceMappingURL=config.js.map